"use client";

import dynamic from "next/dynamic";

const Navbar    = dynamic(() => import("@/components/navbar"),    { ssr: false, loading: () => <div className="p-4 text-center">Loading navbar…</div> });
const LinkIntro = dynamic(() => import("./link-intro"),          { ssr: false, loading: () => <div className="p-4 text-center">Loading intro…</div> });
const LinkCard  = dynamic(() => import("./link-card"),           { ssr: false, loading: () => <div className="p-4 text-center">Loading cards…</div> });

export default function LinkPortal() {
  return (
    <div className="relative min-h-screen w-full bg-[#eff6ff] pt-[7rem]">
      <Navbar />
      <div className="container px-10 mx-auto">
        <LinkIntro />
        <LinkCard />
      </div>
    </div>
  );
}
